import React from 'react';
import { RefreshCw, Archive } from 'lucide-react';
import { Button } from '../ui/button';
import { Label } from '../ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { SERVICES, PRIORITIES, STATUSES, STATIONS } from '../../utils/kitchenTasks';

const ALL = '__all';
const fieldCls = 'h-11 rounded-xl bg-gray-100 border-gray-200 text-gray-800 text-sm';

const FilterSelect = ({ label, value, onChange, options, testId, allLabel = 'Tous' }) => (
  <div>
    <Label className="text-gray-500 text-xs">{label}</Label>
    <Select value={value || ALL} onValueChange={(v) => onChange(v === ALL ? '' : v)}>
      <SelectTrigger className={`mt-1 ${fieldCls}`} data-testid={testId}><SelectValue /></SelectTrigger>
      <SelectContent className="bg-white border-gray-200">
        <SelectItem value={ALL}>{allLabel}</SelectItem>
        {options.map(o => <SelectItem key={o.value} value={o.value}>{o.label}</SelectItem>)}
      </SelectContent>
    </Select>
  </div>
);

const TaskFilters = ({ filters, onChange, collaborators, onRefresh, loading }) => {
  const set = (k) => (v) => onChange({ ...filters, [k]: v });
  return (
    <div className="bg-white border border-gray-200 rounded-2xl p-3 md:p-4" data-testid="task-filters">
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-2 md:gap-3">
        <div>
          <Label className="text-gray-500 text-xs">Date</Label>
          <input type="date" value={filters.date} onChange={(e) => set('date')(e.target.value)}
            className={`mt-1 block w-full px-3 border ${fieldCls} focus:outline-none focus:ring-2 focus:ring-neon-pink/50`} data-testid="filter-date-input" />
        </div>
        <FilterSelect label="Service" value={filters.service} onChange={set('service')} options={SERVICES} testId="filter-service-select" />
        <FilterSelect label="Catégorie" value={filters.category} onChange={set('category')} options={STATIONS.map(s => ({ value: s.id, label: s.label }))} testId="filter-category-select" allLabel="Toutes" />
        <FilterSelect label="Collaborateur" value={filters.assigned_user_id} onChange={set('assigned_user_id')} options={collaborators.map(c => ({ value: c.id, label: c.name }))} testId="filter-collab-select" />
        <FilterSelect label="Statut" value={filters.status} onChange={set('status')} options={STATUSES} testId="filter-status-select" />
        <FilterSelect label="Priorité" value={filters.priority} onChange={set('priority')} options={PRIORITIES} testId="filter-priority-select" allLabel="Toutes" />
      </div>
      <div className="flex flex-wrap items-center gap-2 mt-3">
        <Button variant="outline" size="sm" onClick={onRefresh} disabled={loading} className="h-10 rounded-full border-gray-200 text-gray-700" data-testid="tracking-refresh-btn">
          <RefreshCw size={14} className={`mr-1.5 ${loading ? 'animate-spin' : ''}`} />Actualiser
        </Button>
        <Button variant={filters.archived ? 'default' : 'outline'} size="sm" onClick={() => set('archived')(!filters.archived)}
          className={`h-10 rounded-full ${filters.archived ? 'bg-gray-800 text-white' : 'border-gray-200 text-gray-700'}`} data-testid="filter-archived-toggle">
          <Archive size={14} className="mr-1.5" />{filters.archived ? 'Archivées' : 'Voir les archivées'}
        </Button>
        <Button variant="ghost" size="sm" onClick={() => onChange({ ...filters, service: '', category: '', assigned_user_id: '', status: '', priority: '', quick: '' })} className="h-10 rounded-full text-gray-500" data-testid="filter-reset-btn">
          Réinitialiser les filtres
        </Button>
      </div>
    </div>
  );
};

export default TaskFilters;
